import translationutil from '@/util/translationutil'

export default {
  methods: {
    $t_netdb(item) {
      return translationutil.translate_netdb_ot_lang_attr(item, this.$store.state)
    }
  }
}
